import { render, staticRenderFns } from "./weChat.vue?vue&type=template&id=64134c40&scoped=true"
import script from "./weChat.vue?vue&type=script&lang=js"
export * from "./weChat.vue?vue&type=script&lang=js"
import style0 from "./weChat.vue?vue&type=style&index=0&id=64134c40&prod&lang=scss&scoped=true"
import style1 from "./weChat.vue?vue&type=style&index=1&id=64134c40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64134c40",
  null
  
)

export default component.exports